// extracted by mini-css-extract-plugin
module.exports = {"ErrorContainer":"ErrorMessage_ErrorContainer___YFlB","ErrorTitle":"ErrorMessage_ErrorTitle__wzHc6","ErrorMessage":"ErrorMessage_ErrorMessage__UUkqW"};